/*
 *   File : kyc-status.js
 *   Author URI : https://evoqins.com
 *   Description : Fetch data from digi locker.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useLayoutEffect } from "react";
import { Modal } from "bootstrap";

import { toast } from 'react-toastify';

import { CustomLoader } from "../../Component/Other";

import APIService from "../../Service/api-service";
import Store from "../../Store";
import {
    clearAdminRpdToken,
    clearRpdPollPending,
    getAdminRpdToken,
    getRpdReturnUrl,
    pollRpdUntilComplete,
    setAdminRpdToken,
    setRpdPollPending,
} from "../../Helper/rpd";

const _dismissUnlockModal = () => {
    const unlockModalEl = document.getElementById('unlock-modal');

    if (unlockModalEl) {
        const modalInstance = Modal.getInstance(unlockModalEl);
        modalInstance?.hide();
    }

    document.querySelector('.modal-backdrop')?.remove();
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
};

export default function DigioCallback() {

    useLayoutEffect(() => {
        const query_params = new URLSearchParams(window.location.search);

        if (query_params.get('verification-type') === 'rpd') {
            setRpdPollPending();
            _dismissUnlockModal();
        }
    }, []);

    useEffect(() => {
        const query_params = new URLSearchParams(window.location.search);
        const verification_type = query_params.get("verification-type")
        const is_manual = query_params.get("is_manual");
        const kycFlow = query_params.get("kycFlow") === 'true';
        const adminToken = query_params.get("token");
        let callback_api_url = '';

        if (verification_type === 'rpd') {
            if (adminToken) {
                setAdminRpdToken(adminToken);
            }

            const useOrderApi = Boolean(adminToken || getAdminRpdToken());
            _handleRpdCallback(kycFlow, useOrderApi);
            return;
        }

        switch (verification_type) {
            case 'address': callback_api_url = 'kyc/digilocker/callback';
                break;
            case 'ipv': callback_api_url = 'kyc/ipv/callback';
                break;
            case 'esign': callback_api_url = is_manual == 'true' ? 'kyc/esign/callback-agreement' : 'kyc/esign/callback';
                break;

        }

        _digioCallback(callback_api_url, verification_type);
    }, []);

    function _finishRpdRedirect(returnUrl) {
        clearRpdPollPending();
        clearAdminRpdToken();
        window.location.href = returnUrl;
    }

    function _handleRpdCallback(kycFlow, useOrderApi) {
        pollRpdUntilComplete({
            kycFlow,
            useOrderApi,
            onSuccess: (response) => {
                const returnUrl = getRpdReturnUrl(kycFlow, useOrderApi);
                const message = (response?.message || '').toLowerCase();
                const isAlreadyExists = message.includes('already exists');

                if (kycFlow && response.kyc_data) {
                    Store.dispatch({
                        type: 'KYC_PROGRESS',
                        payload: response.kyc_data
                    });
                }
                toast.dismiss();
                toast.success(
                    isAlreadyExists
                        ? 'Bank account already verified'
                        : 'Bank account verified successfully'
                );
                _finishRpdRedirect(returnUrl);
            },
            onFailure: (response) => {
                toast.dismiss();
                toast.error(response.message || 'Bank verification failed', { type: 'error' });

                const isTimeout = response?.status_code === 408 || response?.status_code === 500;
                if (isTimeout !== true) {
                    return;
                }

                const returnUrl = getRpdReturnUrl(kycFlow, useOrderApi);
                setTimeout(() => {
                    _finishRpdRedirect(returnUrl);
                }, 3000);
            },
        });
    }

    async function _digioCallback(url, type) {
        try {
            const response = await APIService(false, url);

            if (response.status_code === 200) {
                if (type === "ipv") {
                    const pdfStatus = await _generatePdf();
                    console.log("PDF generated:", pdfStatus);
                }
                window.location.href = "/kyc";
            } else {
                toast.dismiss();
                toast.error(response.message);
                setTimeout(() => {
                    window.location.href = "/kyc";
                }, 3000);
            }
        } catch (error) {
            console.error("Error in _digioCallback:", error);
            toast.error("Something went wrong.");
        }
    }

    function _generatePdf() {
        const url = "kyc/generate-pdf";
        return APIService(false, url).then((response) => {
            return response.status;
        });
    }


    return (
        <div className="w-100 h-100vh d-flex justify-content-center align-items-center">
            <CustomLoader />
        </div>
    )

}
